import { render } from "./infoIconSolid.vue?vue&type=template&id=2836edf7"
import script from "./infoIconSolid.vue?vue&type=script&lang=js"
export * from "./infoIconSolid.vue?vue&type=script&lang=js"

import "./infoIconSolid.vue?vue&type=style&index=0&id=2836edf7&lang=scss"

import exportComponent from "/codebuild/output/src2572605020/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__